import script from "./CheckItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckItem.vue?vue&type=script&setup=true&lang=ts"

import "./CheckItem.vue?vue&type=style&index=0&id=273ce3ad&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-273ce3ad"]])

export default __exports__